module.exports = __webpack_public_path__ + "live-join-phone-1baef09e.png";